import { TextAreaInput, TextInput } from '@framework/form';
import React from 'react';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { getWidgetProps } from '../common/util/getWidgetProps';
import { ITextWidget, TextWidgetKind } from './ITextWidget';

export interface ITextWidgetComponentProps
  extends IWidgetComponentProps<ITextWidget> {}

export function TextWidgetComponent(props: ITextWidgetComponentProps) {
  const options = getWidgetProps(props);

  const lengthRule = props.widget.rules?.lengthRange;

  return (
    <ConfigFormItem
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={<RichTextAdvancedRender inline text={options.helpText} />}
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
    >
      {props.widget.kind === TextWidgetKind.TextArea ? (
        <TextAreaInput
          name={options.name}
          placeholder={options.placeholder}
          value={options.value as any}
          minLength={lengthRule?.min ?? undefined}
          maxLength={lengthRule?.max ?? undefined}
          tabIndex={options.preview ? -1 : undefined}
          readOnly={props.readonly}
        />
      ) : (
        <TextInput
          name={options.name}
          placeholder={options.placeholder}
          value={options.value as any}
          minLength={lengthRule?.min ?? undefined}
          maxLength={lengthRule?.max ?? undefined}
          tabIndex={options.preview ? -1 : undefined}
          readOnly={props.readonly}
        />
      )}
    </ConfigFormItem>
  );
}
